import { SignupForm } from './dumb.js';
import enhance from './enhancer';

export default enhance(SignupForm);
